import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import AdminModal from '../AdminModal.js';

const CreateTeamModal = ({ isOpen, onClose, onSubmit, loading }) => {
  const [teamName, setTeamName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (teamName.trim() === '') {
      alert('Team name is required');
      return;
    }
    onSubmit(teamName);
    setTeamName('');
  };

  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      title="Create New Team"
      containerClassName="admin-add-user-modal"
      actions={(
        <>
          <button className="admin-modal-cancel-button" onClick={onClose}>Cancel</button>
          <button
            className="admin-submit-button"
            onClick={handleSubmit}
            disabled={loading || !teamName}
          >
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Create Team'}
          </button>
        </>
      )}
    >
      <form onSubmit={handleSubmit}>
        <div className="admin-form-group">
          <label htmlFor="teamName">Team Name:</label>
          <input
            type="text"
            id="teamName"
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            required
            placeholder="Enter team name"
          />
        </div>
      </form>
    </AdminModal>
  );
};

export default CreateTeamModal;
